<template>
  <v-layout column>
    <v-flex xs11 offset-xs0>
      <panel  v-bind:title='title'>
        <v-btn
          slot="action"
          class="indigo accent-1"
                   
          light
          small
          absolute
          right
          middle
          fab
        >
          <v-icon>add</v-icon>
        </v-btn>
        <PersonCreate v-if ='$store.state.isEditor' slot="action"/>
        <div slot="top">
          <PeopleSearchTable  v-bind:showUnitCol='true'/> <!-- removed v-bind:startSurname='$route.query.surname' -->
        </div>         
      </panel>
            
    </v-flex>
  </v-layout>
</template>

<script>

import Panel from "@/components/Panel" ;
import PeopleSearchTable from "@/components/PeopleSearchTable" ;
import PersonCreate from "./PersonCreate" ;
export default {
  components: {
    Panel, PeopleSearchTable, PersonCreate
  },
  data () {
    return {      
      title: 'Browse People'
    };
  },
  methods: { 
  },
  async created () {
    await this.$getCodes() ;  // needed for everything - make sure we have them and they are up to date
  },
  async mounted () {
    console.log("++++++++++++++++++++++++++++++++ PEOPLE MOUNTED") ;
    if (this.$route.query.description) this.title = "People with " + this.$route.query.description ;
  }  
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/People.vue